export default "__VITE_ASSET__BERfLaAN__"